<template>
  <k-editor-form v-if="active && group" column-scroll>

    <template v-slot:left>
      <k-search-bar v-model="search"></k-search-bar>
      <content-tree
        v-model="selected" 
        :search="search" 
        selectable 
        selection-type="independent"
      />
    </template>

    <template v-slot:right>
        <multi-select label="Content list types" :items="content_list_types" v-model="group.cms_list_types" item-text="name" item-value="id" allow-empty></multi-select>

        <div class="ks-groups-content-lists-missing-types">
          <label class="ks-autocomplete-label mb-2">Missing content list types</label>
          <span v-for="list in missing_content_list_types">
            <k-chip color="warning" size="s" close @click:close="add_list_type(list)" close-icon="add">
              {{ get_list_type_name(list) }}
            </k-chip>
            
          </span>
        </div>

        <k-panel class="elevation-0" title="Preview">
          <content-tree
            v-show="selected.length > 0" 
            :preview-items="selected" 
            open-all
            removable
            @remove="on_remove"
          >
<!--             <template v-slot:append="slotProps">
              <k-btn icon 
                icon-name="close" 
                size="xs" 
                no-margin
                @click="remove_list(slotProps.item)"
              ></k-btn>
            </template> -->
          </content-tree>
        </k-panel>
    </template>

    <template v-slot:right-buttons>
      <k-btn size="m" flat @click="reset">Reset</k-btn>
      <k-btn size="m" color="danger" v-show="is_edit && group.state != 'archived'" @click="changeState('archived')">Archive</k-btn>
      <k-btn size="m" color="danger" v-show="is_edit && group.state == 'archived'" @click="changeState('active')">Unarchive</k-btn>
      <k-btn size="m" color="success" @click="save(false)">Save</k-btn>
      <k-btn size="m" color="success" @click="save(true)">Save and close</k-btn>
    </template>
  </k-editor-form>
</template>

<script>
import ContentTree from '@/components/content/Tree'
import MultiSelect from '@/components/MultiSelect'
import SideBar from '@/components/SideBar.vue'
import Vue from 'vue'

export default {
  props: ['id'],
  components: {
    ContentTree,
    MultiSelect,
    SideBar
  },
  data () {
    var ch = this.$cloudserver.channel("groups:"+(this.id||"create"));
    return {
      ws_channel: ch,
      group: this.convertGroup(ch.data),
      active: this.$route.query.tab == "content_lists",
      selected_list_types: [],
      search: "",

    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.group = this.convertGroup(newVal, oldVal);
        }
      },
      deep: true
    },
    '$route' (to, from) {
      if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
        this.ws_channel = this.$cloudserver.channel("groups:"+this.id);
        this.ws_channel.join();
      }
    },
    "$route.query.tab" (newVal) {
      if(newVal == "content_lists") {
        this.active = true;
      }
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    selected: {
      get() {
        return (this.group && this.group.cms_lists) ? this.group.cms_lists : [];
      },
      set(val) {
        this.group.cms_lists = val;
      }
    },
    missing_content_list_types() {
      let missing = new Set();
      if (!this.group || !this.group.cms_list_types) return missing;
      for(const list of this.selected) {
        if (this.cms_lists[list]) {
          let list_type = this.cms_lists[list].cms_list_type_id;
          if(!this.group.cms_list_types.includes(list_type)) {
            missing.add(list_type)
          }
        }
      }
      return missing;
    },
    cms_lists() {
      if(this.$store.getters.is_privilege(["developer"])) {
        return this.$store.state.cms_lists;
      }
      return this.$store.state.cms_lists_no_sys;
    },
    is_edit () {
      return typeof(this.group) != "undefined" && this.group.id != null;
    },
    content_list_types () {
      return Object.values(this.$store.state.cms_list_types);
    },
  },
  methods: {
    on_remove(item) {
      this.selected = this.selected.filter(id => !item.keys.includes(String(id)));
    },
    add_list_type(list) {
      this.group.cms_list_types.push(list)
    },
    get_list_type_name(list) {
      return this.$store.state.cms_list_types[list].name;
    },
    filter_channels(channels_list, values) {
      var ids = _.map(values, function(v) {
        return v.uuid;
      });
      return _.filter(channels_list, function(channel_id) {
        return ids.includes(channel_id);
      });
    },
    convertGroup (newVal, oldVal) {
      var group = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }
      if(typeof(group) == "undefined" || _.isEmpty(group)) return undefined;
      
      if (!group.cms_list_types) {
        Vue.set(group, 'cms_list_types', []);
      }

      return group;
    },
    changeState (state) {
      this.group.state = state;
      this.save(false);
    },
    reset () {
      this.group = this.convertGroup(this.ws_channel.data);
    },
    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
        var group = _.cloneDeep(this.group);
        group.cms_lists = this.selected;

        this.ws_channel.save({group: group})
          .then((msg) => {
            self.$message.success("Group was updated!");
            if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }
          })
          .catch((msg) => {
            console.log(msg);
            self.$message.warning("Unable to update group!");
          });
      }
    }
  }
}
</script>

<style scoped>
.ks-groups-content-lists-missing-types {
  min-height: 47px;
  margin-bottom: var(--ks-margin-1);
}
</style>